module.exports = __webpack_public_path__ + "static/media/pizza.287d53ae.jpeg";